/**
 * Workflow Hooks using React Query
 * 
 * Handles workflow operations with React Query
 */

import { useQuery } from '@tanstack/react-query';
import { 
  getWorkflows,
  type GetWorkflowsParams
} from '@/services/workflow';

/**
 * Query key factory for workflows
 */
export const workflowKeys = {
  all: ['workflows'] as const,
  lists: () => [...workflowKeys.all, 'list'] as const,
  list: (params?: GetWorkflowsParams) => [...workflowKeys.lists(), params] as const,
};

/**
 * Hook to fetch workflows list
 * 
 * @example
 * const { data, isLoading, error } = useWorkflows({
 *   user_id: 'user-123',
 *   limit: 10,
 *   offset: 0
 * });
 */
export function useWorkflows(params?: GetWorkflowsParams) {
  return useQuery({
    queryKey: workflowKeys.list(params),
    queryFn: () => getWorkflows(params),
    enabled: !!params?.user_id, // Only fetch if user_id is provided
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
